import { FEATURE_FLAGS } from '../../shared/utils/constants';

export function isFeatureEnabled(feature) {
  if (!feature) return true;
  return FEATURE_FLAGS[feature] !== false;
}
